import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6me/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6me/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dtereqst !== 'undefined' ? searchParams.dtereqst : ''),
        p_dteen: (typeof searchParams.dtereqen !== 'undefined' ? searchParams.dtereqen : ''),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres6me/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres6me/cancel/' + params)
  },
  postSaveCancel (saveParams) {
    if (isMock) return generator(mocker.saveCancel())
    return instance().post(endpoint + '/hres6me/cancel', saveParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6me/index.js